export default __webpack_public_path__ + "static/media/second_img.14f024a2.svg";